import { render, staticRenderFns } from "./SalesDashboard.vue?vue&type=template&id=6a69a4ac&scoped=true"
import script from "./SalesDashboard.vue?vue&type=script&lang=js"
export * from "./SalesDashboard.vue?vue&type=script&lang=js"
import style0 from "./SalesDashboard.vue?vue&type=style&index=0&id=6a69a4ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a69a4ac",
  null
  
)

export default component.exports